export const WINDOW_IVA_NAMESPACE = 'sznIVA';
export const ERROR_STORAGE_NAME = 'errorStorage';
export const BASE_URL = 'https://confessor.iva.seznam.cz';
